import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__